import { render, staticRenderFns } from "./companyApplyAdd.vue?vue&type=template&id=1f8c5be4&scoped=true&"
import script from "./companyApplyAdd.vue?vue&type=script&lang=js&"
export * from "./companyApplyAdd.vue?vue&type=script&lang=js&"
import style0 from "./companyApplyAdd.vue?vue&type=style&index=0&id=1f8c5be4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c5be4",
  null
  
)

export default component.exports